import React, { useEffect, useRef, useState } from 'react'
import './ColorCycleButton.css'

interface ColorCycleButtonProps {
  direction: 'next' | 'prev'
  onClick?: () => void
  style?: React.CSSProperties
  icon?: 'cycle' | 'solid'
  active?: boolean
  label?: string
}

const LED_HOLD_MS = 450

export const ColorCycleButton: React.FC<ColorCycleButtonProps> = ({
  direction,
  onClick,
  style,
  icon = 'cycle',
  active = false,
  label,
}) => {
  const [lit, setLit] = useState(false)
  const timer = useRef<number>()

  useEffect(() => () => window.clearTimeout(timer.current), [])

  const light = () => {
    setLit(true)
    window.clearTimeout(timer.current)
    timer.current = window.setTimeout(() => setLit(false), LED_HOLD_MS)
  }

  const text =
    label ??
    (icon === 'solid'
      ? active
        ? 'Separate colors'
        : 'One color'
      : direction === 'next'
        ? 'Next color'
        : 'Previous color')

  return (
    <button
      className={`color-cycle-btn ${direction}${lit ? ' lit' : ''}${
        active ? ' active' : ''
      }`}
      onPointerDown={light}
      onClick={onClick}
      style={style}
      aria-label={text}
      aria-pressed={icon === 'solid' ? active : undefined}
      title={text}
    >
      <svg
        className="cycle-icon"
        viewBox="0 0 24 24"
        aria-hidden="true"
        focusable="false"
      >
        {icon === 'solid' ? (
          <text
            x="12"
            y="17.2"
            textAnchor="middle"
            fill="currentColor"
            fontFamily="Arial, sans-serif"
            fontSize="16"
            fontWeight="700"
          >
            M
          </text>
        ) : (
          <g transform={direction === 'prev' ? 'translate(24 0) scale(-1 1)' : undefined}>
            <rect x="4" y="5" width="8.5" height="3" rx="1.2" fill="currentColor" />
            <rect x="4" y="10.5" width="8.5" height="3" rx="1.2" fill="currentColor" />
            <rect x="4" y="16" width="8.5" height="3" rx="1.2" fill="currentColor" />
            <path
              d="M15.5 7.4 20.1 12l-4.6 4.6"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
        )}
      </svg>
    </button>
  )
}

export default ColorCycleButton
